import styled from 'styled-components';
import { colors, media } from '../../settings';

export const DealerCont = styled.div`
  background-color: ${colors.grey1};
  padding: 30px 40px;
  margin: 30px 0;
`;

export const LeftSide = styled.div`
  width: 100%;
  ${media.greaterThan('lg')`
    width: 50%;
    display: inline-block;
    vertical-align: bottom;
  `};
`;
export const RightSide = styled.div`
  margin-top: 20px;

  ${media.greaterThan('lg')`
    width: 50%;
    text-align: right;
    display: inline-block;
    vertical-align: bottom;
  `};
`;

export const Content = styled.div`
  display: inline-block;
  vertical-align: top;
  margin-right: 20px;
`;
export const Award = styled.div`
  display: inline-block;
  vertical-align: top;
`;
